var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "contest-entry-complete" }, [
    _c("h2", [_vm._v(_vm._s(_vm.$t("contestEntryComplete.title")))]),
    _c("p", [_vm._v(_vm._s(_vm.$t("contestEntryComplete.thankYou")))]),
    _c("p", [_vm._v(_vm._s(_vm.$t("contestEntryComplete.scheduleNotice")))]),
    _c("br"),
    _c(
      "table",
      { attrs: { border: "1" } },
      _vm._l(_vm.contest.schedule, function (schedule) {
        return _c("tr", { key: schedule.name }, [
          _c("th", [_vm._v(_vm._s(schedule.name))]),
          _c("td", [_vm._v(_vm._s(schedule.value))]),
        ])
      }),
      0
    ),
    _c("br"),
    _c("p", [_vm._v(_vm._s(_vm.$t("contestEntryComplete.emailNotice")))]),
    _c("br"),
    _c("p", [_vm._v(_vm._s(_vm.$t("contestEntryComplete.closing1")))]),
    _c("p", [_vm._v(_vm._s(_vm.$t("contestEntryComplete.closing2")))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }